import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./account-initial";

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    onLoading(state, action) {
      state.isLoading[action.payload] = true;
    },
    rejectedActions(state, action) {
      state.isLoading[action.payload.name] = false;
      state.error = action.payload;
    },
    loadedAllUsers(state, action) {
      state.allUsers = action.payload;
      state.isLoading.allUsers = false;
    },
    appendedNewUser(state, action) {
      state.allUsers = [...state.allUsers, action.payload];
    },
    loadedUser(state, action) {
      state.user = action.payload;
      state.isLoading.user = false;
    },
    resetUser(state) {
      state.user = initialState.user;
    },
    resetAllUsers(state) {
      state.allUsers = initialState.allUsers;
    },
    updatedUser(state, action) {
      const updatedUser = action.payload;
      const updatedIndex = state.allUsers.findIndex(
        (user) => user.id === updatedUser.id
      );
      state.allUsers[updatedIndex] = updatedUser;
      state.isLoading.user = false;
    },
    disabledUser(state, action) {
      state.allUsers = state.allUsers.filter(
        (user) => user.id !== action.payload.id
      );
      state.isLoading.allUsers = false;
    },
  },
});

export const accountActions = accountSlice.actions;

export default accountSlice.reducer;
